import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const MediaManagerComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "MediaManagerPage" */ "@circle-react/components/SettingsApp/MediaManager"
    ),
);

export const MediaManagerPage = () => (
  <Suspense fallback={<PageLoader />}>
    <MediaManagerComponent />
  </Suspense>
);
